import { assetsActions, assetsReducer } from './assets/slice';
import { tablesActions, tablesReducer } from './tables/slice';

export const reducers = {
	assets: assetsReducer,
	tables: tablesReducer
};

export const actions = {
	...assetsActions,
	...tablesActions
};
